import { ApiError } from './http.js';
/**
 * La phrase que le serveur a écrite, pour les gestes **en ligne** des deux fronts.
 *
 * ⚠️ **On ne réécrit pas ces messages** : un `409` dit pourquoi il refuse et quoi faire ensuite,
 * ce que seul le serveur sait. Pas `error.message` non plus, qui n'est que « PATCH … → 409 ».
 */
export function serverMessage(error) {
    if (error === null || error === undefined)
        return null;
    if (error instanceof ApiError) {
        // `ConflictException` comme le refus Zod (`DetailedZodBody`) écrivent dans `message`.
        const message = error.body?.message;
        if (typeof message === 'string' && message !== '')
            return message;
        return `Le serveur a refusé (${String(error.status)}).`;
    }
    return 'Le serveur n’a pas répondu. Rien n’est enregistré : réessayez.';
}
//# sourceMappingURL=server-message.js.map